import * as ents from '@attain-apps/entities'
import * as store from '@attain-apps/fe/web/main/lib/store'
import { TypeChecker } from '@attain-apps/type-guards'
import * as rxjs from 'rxjs'

import type * as currentRendering from '../../../feature'
import type { Feature } from '../feature'

/** Determines how action will be executed based on provided action context  */
export const actionExecutions = store.effects.create(
  (feature: Feature, currentRenderingFeature: currentRendering.Feature) =>
    feature.actions.executeAction.relay((forwardTo, actionHandler) =>
      currentRenderingFeature.selectors.context.asObservable.pipe(
        // NOTE:  Retrieve current context immediately without waiting for
        // future emissions take(1) gets only the current value filter verifies
        // context exists, if it doesn't don't do anything
        rxjs.take(1),
        rxjs.filter(TypeChecker.isNotNullish.raw),
        rxjs.map(pageContext => {
          const {
            context: { actionRef, id: handlerId },
          } = actionHandler
          const { action } = actionRef
          if (
            ents.core.common.FlexibleIdentifier.isFlexibleIdentifier(action)
          ) {
            // If action id is provided, forward to the submit action instruction
            const submitActionInstruction = forwardTo(
              feature.actions.submitAction,
              {
                input: {
                  ...pageContext,
                  handlerId: handlerId,
                  // TODO: Move this logic elsewhere to reduce complexity in this effect
                  pageContext: pageContext,
                  ref: {
                    ...actionRef,
                    variables: actionRef.variables,
                  },
                },
                output: ({ response }) => response,
              },
            )

            return actionRef.confirm
              ? {
                  // If confirmation is required, execute confirmation action
                  // first and then forward to the submit action instruction
                  sequence: [
                    forwardTo(feature.actions.confirmAction, {
                      input: { context: actionHandler.context },
                      // TODO output should be removed (it is not going to be
                      // used), but TypeScript is complaining
                      output: () => ({ executedInUi: [] }),
                    }),
                    submitActionInstruction,
                  ],
                }
              : // Otherwise just forward to the submit action instruction
                submitActionInstruction
          }

          if (actionRef.confirm) {
            // If action is inline and confirmation is required, execute
            // confirmation action and provide inline action data in output
            // after confirmation
            return forwardTo(feature.actions.confirmAction, {
              input: { context: actionHandler.context },
              output: () => ({ executedInUi: [action] }),
            })
          }

          // If action is inline and confirmation is not required, return inline
          // action data
          return {
            success: {
              response: { executedInUi: [action] },
            },
          }
        }),
      ),
    ).asObservable,
)
